import { getAPIPath, requestGooseAPI } from '../shared/request'
import { APIContractClientDtoResponse, ContractClientDto } from '../types/api'
import { CLIENT_CONTRACTS_ID_PATH, CLIENT_CONTRACTS_PATH } from '../types/constants'
import { TContractType } from '../types/general'

export const ClientContractsService = {
  get: (locationId: string, contractType?: TContractType): Promise<ContractClientDto | null> => {
    return requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: { type: contractType },
    }).then((res) => res?.results?.[0] ?? null)
  },

  list: (locationId: string, contractType?: TContractType): Promise<APIContractClientDtoResponse | null> => {
    return requestGooseAPI<APIContractClientDtoResponse>({
      url: getAPIPath(CLIENT_CONTRACTS_PATH, { locationId }),
      method: 'GET',
      params: { type: contractType },
    })
  },

  getContract: (locationId: string, id: string): Promise<ContractClientDto | null> => {
    return requestGooseAPI<ContractClientDto>({
      url: getAPIPath(CLIENT_CONTRACTS_ID_PATH, { locationId, id }),
      method: 'GET',
    })
  },
}
